var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 80",
    shapeRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ff0000",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 40,
    x2: 165,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 28,
    x2: 180,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 52,
    x2: 180,
    y2: 40
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e2e56c37a5e47625b66f28f9bd5b7258.svg";
export { ForwardRef as ReactComponent };